import { render } from "./Announcement.vue?vue&type=template&id=32ea2475&scoped=true&lang=pug"
import script from "./Announcement.vue?vue&type=script&lang=ts"
export * from "./Announcement.vue?vue&type=script&lang=ts"

import "./Announcement.vue?vue&type=style&index=0&id=32ea2475&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-32ea2475"

export default script